import React, { useState } from 'react';
import { ExternalLink } from 'lucide-react';

function BlinkingIcon() {
  const [showLink, setShowLink] = useState(false);
  const websiteUrl = 'https://aurum-897fb.web.app/';

  return (
    <div style={styles.container}>
      {/* Icon */}
      <ExternalLink
        size={80}
        color="#09c7d8"
        style={styles.icon}
        onClick={() => setShowLink(!showLink)}
      />

      {/* Link (shown after click) */}
      {showLink && (
        <a
          href={websiteUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={styles.link}
        >
          Open Website
        </a>
      )}

      {/* Animation */}
      <style>{`
        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.3; }
        }
      `}</style>
    </div>
  );
}

const styles = {
  container: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px',
    background: 'black',
  },
  icon: {
    animation: 'blink 1.2s infinite',
    filter: 'drop-shadow(0 0 20px gold)',
    cursor: 'pointer',
  },
  link: {
    color: '#09c7d8',
    fontSize: '18px',
    textDecoration: 'none',
    border: '1px solid #09c7d8',
    padding: '10px 20px',
    borderRadius: '8px',
    transition: '0.3s',
  },
};

export default BlinkingIcon;
